import { render, staticRenderFns } from "./Disassignments.vue?vue&type=template&id=2205613e&scoped=true&"
import script from "./Disassignments.vue?vue&type=script&lang=js&"
export * from "./Disassignments.vue?vue&type=script&lang=js&"
import style0 from "./Disassignments.vue?vue&type=style&index=0&id=2205613e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2205613e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2205613e')) {
      api.createRecord('2205613e', component.options)
    } else {
      api.reload('2205613e', component.options)
    }
    module.hot.accept("./Disassignments.vue?vue&type=template&id=2205613e&scoped=true&", function () {
      api.rerender('2205613e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AssignationMultiple/Disassignments.vue"
export default component.exports